// src/features/executive/shared/utils/master-slice.ts
// Display helpers for widgets whose slices come one-per-master-row from the
// backend (payment channels, operative types): pick the label for the UI
// language and a stable colour per position, with a neutral colour for the
// backend's catch-all "other" bucket.
import { paletteColor } from './palette'

export const OTHER_SLICE_KEY = 'other'
export const OTHER_SLICE_COLOR = '#9e9e9e'

export interface MasterSlice {
  key: string
  label: string
  labelEn: string
}

export function masterSliceLabel(slice: Pick<MasterSlice, 'label' | 'labelEn'>, language: string | undefined): string {
  const isEnglish = `${language || ''}`.toLowerCase().startsWith('en')
  return (isEnglish && slice.labelEn) || slice.label
}

export function masterSliceColor(slice: Pick<MasterSlice, 'key'>, position: number): string {
  return slice.key === OTHER_SLICE_KEY ? OTHER_SLICE_COLOR : paletteColor(position)
}
